module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-card"
  }, [_c('h2', {
    staticClass: "k6-green-text text-center",
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.login.login")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "google-login-btn",
    attrs: {
      "name": "GoogleSigninButton"
    },
    on: {
      "click": _vm.loginSsoGoogle
    }
  }, [_c('img', {
    staticClass: "google-icon",
    attrs: {
      "src": require("../../assets/google.png")
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t("pages.login.google")) + "\n    ")])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    staticStyle: {
      "padding": "10px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitData($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    attrs: {
      "for": "inputEmail3"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.login.username')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputEmail3",
      "autofocus": ""
    },
    domProps: {
      "value": _vm.identifier
    },
    on: {
      "input": _vm.updateLoginIdentifier
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    attrs: {
      "for": "inputPassword3"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.login.password')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword3"
    },
    on: {
      "input": _vm.updateLoginPassword
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "id": "remeber"
    },
    domProps: {
      "value": _vm.rememberMe,
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, _vm.rememberMe) > -1 : (_vm.rememberMe)
    },
    on: {
      "input": _vm.updateLoginRememberMe,
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.rememberMe,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(_vm._s(_vm.$t('pages.login.remeberMe')) + "\n          ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "k6-green-text",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLoginResetForm($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.login.forgotPassword')))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "flex-direction": "column",
      "gap": "20px"
    }
  }, [_c('button', {
    staticClass: "k6-primary-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitData($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.login.login')))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("\n          " + _vm._s(_vm.$t("pages.home.helloRegister")) + "\n          "), _c('a', {
    staticClass: "k6-green-text",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toRegister($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.register.register")))])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06f843ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06f843ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/authentication/Login.vue
// module id = 1378
// module chunks = 1